import * as React from "react";
import { useTranslation } from "react-i18next";
import { StyledHeading, DescriptionCol } from "components/inputs/InputSetupWizard";
import IlluminateList from "./IlluminateList";
import { ILLUMINATE_PACK_TYPES } from "../SelectIlluminateStep";
const SelectSpotlightPacks = ({
  spotlightPacksData,
  isLoadingSpotlightPacksData,
  selectedSpotlightPacks,
  setSelectedSpotlightPacks,
  setTouched
}) => {
  const { t } = useTranslation("enterprise_forwarder");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledHeading, null, t("select_spotlight_packs.heading")), /* @__PURE__ */ React.createElement(DescriptionCol, null, /* @__PURE__ */ React.createElement("p", null, t("select_spotlight_packs.intro")), /* @__PURE__ */ React.createElement("p", null, t("select_spotlight_packs.installed_hint"))), /* @__PURE__ */ React.createElement(
    IlluminateList,
    {
      isLoading: isLoadingSpotlightPacksData,
      listData: spotlightPacksData,
      selectedPacks: selectedSpotlightPacks,
      setSelectedPacks: setSelectedSpotlightPacks,
      setTouched,
      type: ILLUMINATE_PACK_TYPES.SPOTLIGHT
    }
  ));
};
export default SelectSpotlightPacks;
